import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import homeImageBackground from "../assets/images/homeBackground.png";
import { auth, firestoredDB } from "../config/firebase";
import { setRecipes } from "../redux/search";
import RecipeCard from "./RecipeCard";
import Swal from "sweetalert";
import CustomModal from "./alerts/CustomModal";
import EditListModal from "./alerts/EditListModal";
import RecipeCardDetails from "./alerts/RecipeCardDetails";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import CookBookLists from "./CookBookLists";
import { playAudio } from "../utils/btnAudio";
import { setCLickedListId } from "../redux/cookbook";
import { ContainerHeading, CookEInput } from "./CommonComponents";
import {
  getCookbookLists,
  getCookBooksRecipes,
  addNewCookbookList,
  deleteCookbookList,
} from "../utils/apiServices/cookbookServices";

export default function CookBook({ setIsDragging }) {
  const dispatch = useDispatch();
  const { recipeCard } = useSelector((state) => state.recipeCard);
  const { clickedListId } = useSelector((state) => state.cookbook);
  const [loading, setLoading] = useState(false);
  const [cookBookData, setCookBookData] = useState([]);
  const [newList, setNewList] = useState("");
  const [listsData, setListsData] = useState([]);
  const [search, setSearch] = useState("");
  const [listId, setList] = useState("");
  const [error, setError] = useState("");
  let [isOpen, setIsOpen] = useState(false);
  let [isOpenR, setIsOpenR] = useState(false);
  const [totalRecipeData, setTotalRecipeData] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  let [deleteR, setDeleting] = useState(false);

  const handleChange = (e) => {
    setIsSearching(true);
    setSearch(e.target.value);
  };

  const getLists = async () => {
    setLoading(true);
    try {
      const res = await getCookbookLists();

      if (res === null) {
        setLoading(false);
        return;
      }

      res.sort((a, b) => a?.order - b?.order);
      setListsData(res);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (auth?.currentUser) {
      getLists();
    }
  }, [auth?.currentUser]);

  const getCookBookList = async () => {
    setLoading(true);
    try {
      const totalRecords = await getCookBooksRecipes();

      const userData =
        clickedListId === null
          ? totalRecords.filter(
              (item) =>
                item.userId === auth?.currentUser?.uid && item.listId === null
            )
          : totalRecords.filter(
              (item) =>
                item.userId === auth?.currentUser?.uid &&
                item.listId === clickedListId
            );

      // Sort userData based on the 'createdAt' timestamp
      userData.sort((a, b) => {
        const dateA = a.createdAt
          ? a.createdAt.seconds * 1000 + a.createdAt.nanoseconds / 1000000
          : 0; // Use 0 if createdAt is missing
        const dateB = b.createdAt
          ? b.createdAt.seconds * 1000 + b.createdAt.nanoseconds / 1000000
          : 0; // Use 0 if createdAt is missing
        return dateB - dateA; // Sort in descending order (newest first)
      });
      //now sort by order
      userData.sort((a, b) => a?.order - b?.order);
      userData.sort((a, b) =>
        a.bookmarked === b.bookmarked ? 0 : a.bookmarked ? -1 : 1
      );

      setCookBookData(userData);
      // reverse the list
      // setCookBookData(userData.reverse());
      setTotalRecipeData(totalRecords);
      dispatch(setRecipes(userData));
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCookBookList();
  }, []);
  useEffect(() => {
    getCookBookList();
  }, [clickedListId]);

  useEffect(() => {
    if (search == "") {
      if (isSearching) {
        dispatch(setCLickedListId(null));
        setIsSearching(false);
      }
      const userData = totalRecipeData?.filter(
        (item) => item.userId === auth?.currentUser?.uid && item.listId === null
      );

      // // Sort userData based on the 'bookmarked' key
      userData.sort((a, b) => a?.order - b?.order);
      userData.sort((a, b) =>
        a.bookmarked === b.bookmarked ? 0 : a.bookmarked ? -1 : 1
      );
      setCookBookData(userData);
    } else {
      const filteredByKeyword = totalRecipeData?.filter((cook) =>
        cook?.description?.toLowerCase().includes(search?.toLowerCase())
      );
      // console.log(totalRecipeData,search?.toLowerCase(),filteredByKeyword)
      const filteredByUser = filteredByKeyword?.filter(
        (item) => item.userId === auth?.currentUser?.uid
      );

      // const searchedItem = totalRecipeData?.filter((cook) =>
      //   cook?.description?.toLowerCase().includes(search?.toLowerCase())
      // );
      setCookBookData(filteredByUser);
    }
  }, [search]);

  const handleChange2 = (e) => {
    console.log("here");
    setNewList(e.target.value);
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    // Do nothing if dropped outside the list
    setIsDragging(false);
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    // Find the index of the last bookmarked item
    const lastBookmarkedIndex = cookBookData.reduce(
      (lastIndex, item, index) => (item.bookmarked ? index : lastIndex),
      -1
    );

    // Check if the item is being moved above any bookmarked item
    console.log(destination.index, lastBookmarkedIndex, "<=============");
    //check if the dragged item also bookmarked
    if (cookBookData[source.index].bookmarked) {
      if (destination.index > lastBookmarkedIndex) {
        // Adjust the destination index to be before the last bookmarked item
        destination.index = lastBookmarkedIndex;
      }
    } else {
      if (destination.index <= lastBookmarkedIndex) {
        // Adjust the destination index to be after the last bookmarked item
        destination.index = lastBookmarkedIndex + 1;
      }
    }

    // Reorder the items
    const reorderedItems = reorder(
      cookBookData,
      source.index,
      destination.index
    );

    // Set the state with reordered items
    setCookBookData(reorderedItems);

    // Update the order in Firestore
    updateCookBookOrder(reorderedItems);
  };

  const onSubmitList = async () => {
    try {
      if (!newList) {
        alert("Please enter a valid value");
      } else {
        const res = await addNewCookbookList(newList);
        if (res) {
          getCookBookList();
          getLists();
          Swal({
            icon: "success",
            title: "List added successfully",
            showConfirmButton: false,
            timer: 2000,
            confirmButtonColor: "#f0481a",
          });
        }
      }
    } catch (err) {
      console.log(err.message);

      Swal({
        icon: "info",
        title: err.message,
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  function closeModal() {
    const alreadyExist = listsData?.filter(
      (item) => item?.name?.toLowerCase() === newList?.toLowerCase()
    );
    if (alreadyExist?.length > 0) {
      setError("A list is already exist with this name");
    } else {
      setError("");
      onSubmitList();
      setIsOpen(false);
      setNewList("");
    }
  }

  function close() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }
  function closeModalR() {
    setIsOpenR(false);
  }

  function closeR() {
    setIsOpenR(false);
  }

  function openModalR() {
    setIsOpenR(true);
  }

  const handleChange3 = (e) => {
    setList(e.target.value);
  };

  const deleteList = async (id) => {
    Swal({
      title: "Are you sure you want to delete?",
      text: "Once deleted you can not undo",
      icon: "warning",
      buttons: ["No, cancel It!", "Yes, I am sure!"],
      dangerMode: true,
    }).then(async (isConfirm) => {
      if (isConfirm) {
        // navigate("/discover-dishes");
        setDeleting(true);
        try {
          const ifRecipesExistInList = totalRecipeData?.filter(
            (item) => item?.listId == id
          );

          if (ifRecipesExistInList?.length > 0) {
            Swal({
              icon: "error",
              title:
                "List can't be deleted as there are some recipes associated with this List!",
              showConfirmButton: false,
              timer: 3000,
            });
          } else {
            const res = await deleteCookbookList(id);
            if (res) {
              getLists();
              Swal({
                icon: "success",
                title: "List deleted successfully",
                showConfirmButton: false,
                timer: 3000,
                confirmButtonColor: "#f0481a",
              });
            }
          }
        } catch (error) {
          Swal({
            icon: "info",
            title: error.message,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        setDeleting(false);
      } else return;
    });
  };

  //Edit modal
  const updateListName = async () => {
    try {
      console.log(newListName, "newListName", clickedListId);
      const movieDoc = doc(firestoredDB, "Lists", clickedListId);
      await updateDoc(movieDoc, { name: newListName });
      const updatedData = listsData?.map((item) => {
        if (item?.id == clickedListId) {
          return { ...item, name: newListName };
        }
        return item;
      });

      setListsData(updatedData);
      // getLists();
      Swal({
        icon: "success",
        title: "List renamed successfully",
        showConfirmButton: false,
        timer: 5000,
        confirmButtonColor: "#f0481a",
      });
    } catch (error) {
      Swal({
        icon: "info",
        title: error.message,
        showConfirmButton: false,
        timer: 6000,
      });
    }

    // getCookBoookData()
  };

  function closeEditListModalAndSubmit() {
    // onSubmitEditListName()
    const alreadyExist = listsData?.filter(
      (item) => item?.name?.toLowerCase() === newListName?.toLowerCase()
    );

    if (alreadyExist?.length > 0) {
      setError("A list is already exist with this name");
    } else {
      setError("");
      updateListName();
      setIsEditModalOpen(false);
      setNewListName("");
    }
  }

  function closeEditListModal() {
    setIsEditModalOpen(false);
    setNewListName("");
  }

  function openEditListModal() {
    setIsEditModalOpen(true);
  }

  const [newListName, setNewListName] = useState("");
  const handleChangeEditListName = (e) => {
    setNewListName(e.target.value);
  };

  // const updateBookmarkedStatus = async (id, status) => {
  //   try {
  //     const movieDoc = doc(firestoredDB, "CookBook", id);

  //     await updateDoc(movieDoc, {
  //       bookmarked: status,
  //     });
  //     const updatedData = cookBookData?.map((item, index) => {
  //       if (item?.id == id) {
  //         return {
  //           ...item,
  //           bookmarked: status,
  //         };
  //       } else return item;
  //     });

  //     //   userData.sort((a, b) =>
  //     //   a.bookmarked === b.bookmarked ? 0 : a.bookmarked ? -1 : 1
  //     // );
  //     updateCookBookOrder(updatedData);
  //     setCookBookData(updatedData);
  //   } catch (error) {
  //     console.log(error);
  //     Swal({
  //       icon: "info",
  //       title: error.message,
  //       showConfirmButton: false,
  //       timer: 10000,
  //     });
  //   }

  //   // getCookBoookData()
  // };

  const updateBookmarkedStatus = async (id, status) => {
    try {
      const movieDoc = doc(firestoredDB, "CookBook", id);

      // Update the Firestore document
      await updateDoc(movieDoc, {
        bookmarked: status,
      });

      // Update the local state
      const updatedData = cookBookData.map((item) => {
        if (item.id === id) {
          return { ...item, bookmarked: status };
        }
        return item;
      });

      // Reorder the updatedData array
      const reorderedData = updatedData.sort((a, b) =>
        a.bookmarked === b.bookmarked ? 0 : a.bookmarked ? -1 : 1
      );

      setCookBookData(reorderedData);

      // Optionally, update Firestore order
      await updateCookBookOrder(reorderedData);
    } catch (error) {
      console.error("Error updating bookmarked status:", error);
      Swal({
        icon: "info",
        title: error.message,
        showConfirmButton: false,
        timer: 10000,
      });
    }
  };

  const updateCookBookOrder = async (orderedData) => {
    setLoading(true); // Assuming you have a loading state
    try {
      // Create a batch to update all documents in one go
      const batch = writeBatch(firestoredDB);

      // Loop over your ordered data
      orderedData.forEach((item, index) => {
        // Check if the document ID exists in the ordered array
        const docRef = doc(firestoredDB, "CookBook", item.id);

        if (orderedData.some((orderedItem) => orderedItem.id === item.id)) {
          // If the document is in the ordered array, update the order
          batch.update(docRef, { ...item, order: index });
        }
      });

      // Commit the batch
      await batch.commit();
    } catch (err) {
      console.error("Error updating documents: ", err);
      // Handle the error appropriately
    }
    setLoading(false);
  };

  const mainContainerRef = useRef(null);

  return (
    <section className="relative h-full" ref={mainContainerRef}>
      <>
        {isOpenR ? (
          <></>
        ) : (
          <div className="flex flex-col h-full">
            <div className="flex-shrink-0">
              {/* Header */}
              <div className="flex mx-4 justify-center items-center">
                <ContainerHeading text="Personal Cookbook" />
              </div>
            
              {/* Search block */}
              <div className="w-full">
                <CookEInput
                  name="search"
                  value={search}
                  className={"!rounded-full"}
                  placeholder="Search what you want..."
                  onChange={handleChange}
                />
              </div>
            </div>
            
            <div className="flex-grow flex md:flex-row flex-col pt-2 justify-start items-start space-x-0 space-y-3 md:space-y-0 md:space-x-2 overflow-hidden h-0 min-h-0">

              {/* Left Side - Cookbook Lists */}
              <div className="flex-[30%] h-full overflow-y-auto overflow-x-hidden pr-2">

                <CookBookLists
                  openModal={openModal}
                  clickedListId={clickedListId}
                  loading={loading}
                  listsData={listsData}
                  onListClick={(id) => {
                    playAudio();
                    dispatch(setCLickedListId(id));
                  }}
                  onDeleteIconClick={(id) => deleteList(id)}
                  search={search}
                  onPencilIconClick={(id) => {
                    dispatch(setCLickedListId(id));
                    setIsEditModalOpen(true);
                  }}
                  onDragStart={() => setIsDragging(true)}
                  onDragEndCustom={() => setIsDragging(false)}
                />
              </div>

              {/* Right Side - Recipe Cards */}
              <div className="no-scrollbar flex-[70%] h-full overflow-y-auto overflow-x-hidden md:px-4 pb-10">

                {cookBookData.length === 0 ? (
                  <p className="dark:text-white text-black text-center text-xl">
                    Your Cookbook is Empty
                  </p>
                ) : (
                  <>
                    <DragDropContext
                      onDragEnd={onDragEnd}
                      onDragStart={() => setIsDragging(true)}
                    >
                      <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {cookBookData?.map((recipe, idx) => {
                              return (
                                <Draggable
                                  key={recipe.id}
                                  draggableId={recipe.id}
                                  index={idx}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      style={{
                                        ...provided.draggableProps.style,
                                      }}
                                    >
                                      <RecipeCard
                                        onClickRC={openModalR}
                                        key={idx}
                                        image={recipe?.imageUrl}
                                        db={firestoredDB}
                                        id={recipe.id}
                                        title={recipe.title}
                                        shareUrl={recipe?.shareUrl}
                                        description={recipe.description}
                                        lists={listsData}
                                        getCookBoookData={getCookBookList}
                                        handleChangeL={handleChange3}
                                        listName={listId}
                                        listValue={listId}
                                        clickedListId={clickedListId}
                                        notes={recipe?.notes}
                                        createdAt={recipe?.createdAt}
                                        bookmarked={recipe?.bookmarked ?? false}
                                        updateBookmarkedStatus={
                                          updateBookmarkedStatus
                                        }
                                        dragHandleProps={
                                          provided.dragHandleProps
                                        }
                                      />
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </>
                )}
                {loading && (
                  <p className="text-white text-center text-xl">
                    Loading data... Please wait
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </>

      <CustomModal
        isOpen={isOpen}
        close={close}
        openModal={openModal}
        newList={newList}
        handleChange={handleChange2}
        closeModal={closeModal}
        error={error}
      />
      <EditListModal
        isOpen={isEditModalOpen}
        close={closeEditListModal}
        openModal={openEditListModal}
        newList={newListName}
        handleChange={handleChangeEditListName}
        closeModal={closeEditListModalAndSubmit}
        error={error}
      />

      <RecipeCardDetails
        isOpen={isOpenR}
        close={closeR}
        openModal={openModalR}
        recipeCardData={recipeCard}
        closeModal={closeModalR}
      />
    </section>
  );
}
